import { utcToZonedTime } from "date-fns-tz";

export const byStartTime = (a, b) => {
    if (!a.stt) {
        return 1;
    }
    if (!b.stt) {
        return -1;
    }
    return utcToZonedTime(new Date(a.stt)) - utcToZonedTime(new Date(b.stt));
};
